import moment from 'moment'
import { Flex, Box, Text } from 'rebass/styled-components'
import { MessageTextStyled, SmsStyleBubbleWorkflow } from '../../../../components/conversation/styled/bubbles'
import { replaceAll } from '../../../../utils/StringUtils'
import { getDateText, getDayText } from './utils'
import { IThread } from '../../../../graphql/types/queries/conversation'

interface ILineItemProps {
  isPatientConvo: boolean, 
  thread: IThread, 
  previousThread?: IThread | null
}

export const LineItem: React.FC<ILineItemProps> = ({ thread, previousThread, isPatientConvo }) => {
  const isSameDay = !previousThread ? false : moment(thread.createdAt).isSame(moment(previousThread.createdAt), 'day')
  return (
    <Flex width={'100%'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}
      mb={'16px'}>
      {!isSameDay && <Box style={{ background: !isPatientConvo ? '#E7BFB9' : '#7F91D4', padding: '4px 8px', minWidth: '150px', borderRadius: '12px' }} mb={3} alignSelf={'center'}><Text fontSize={'14px'} fontWeight={600} textAlign={'center'}>{getDayText(thread)}</Text></Box>}
      <SmsStyleBubbleWorkflow>
        {(thread.action?.type || '').toLowerCase().indexOf('workflow') > -1 && (
          <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 14H0L7 0V8H12L5 22V14Z" fill="white" />
          </svg>
        )}

        <Flex flex={1} ml={3} justifyContent={'center'} alignItems={'center'}>
          <MessageTextStyled fontSize={'14px'} textAlign={'left'} alignSelf={'center'}
            dangerouslySetInnerHTML={{ __html: replaceAll((thread.action?.text || ''), 'You ', 'G from Paloma Health ').replace(' **', '&nbsp;<strong>').replace('** ', '</strong>&nbsp;') }}
          />
        </Flex>
      </SmsStyleBubbleWorkflow>
      <Text mt={1} fontSize={'12px'} opacity={0.65}>{getDateText(thread)}</Text>
    </Flex>
  )
}